import { WebhooksDialog } from '../../../../dev/connect/_components/webhooks/dialog'

export const BreadcrumbWebhook = () => {
  return <WebhooksDialog />
}
